import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Menu, X } from "lucide-react";
import { nav } from "../mock";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-[#0c0c0c]/90 backdrop-blur-md" : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-[1500px] items-center justify-between px-5 py-4 md:px-10">
        <Link to="/" className="flex items-center">
          <img src="/crtr-logo-long.png" alt="CRTR Studios" className="h-6 w-auto md:h-7" />
        </Link>

        <nav className="hidden items-center gap-9 md:flex">
          {nav.map((n) => (
            <a
              key={n.label}
              href={n.href}
              className="mono-label text-xs text-white/90 transition-colors hover:text-[var(--crtr-yellow)]"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <a
          href="mailto:info@all-about-artists.de"
          className="group hidden items-center gap-3 rounded-full bg-[var(--crtr-yellow)] py-2 pl-5 pr-2 md:flex"
        >
          <span className="mono-label text-xs text-black">LET’S TALK</span>
          <span className="flex h-8 w-8 items-center justify-center rounded-full bg-black transition-transform group-hover:translate-x-0.5">
            <ArrowRight className="h-4 w-4 text-[var(--crtr-yellow)]" />
          </span>
        </a>

        <button className="text-white md:hidden" onClick={() => setOpen(!open)} aria-label="Menu">
          {open ? <X className="h-7 w-7" /> : <Menu className="h-7 w-7" />}
        </button>
      </div>

      {open && (
        <div className="border-t border-white/10 bg-[#0c0c0c] px-5 py-6 md:hidden">
          {nav.map((n) => (
            <a
              key={n.label}
              href={n.href}
              onClick={() => setOpen(false)}
              className="mono-label block py-3 text-sm text-white"
            >
              {n.label}
            </a>
          ))}
          <a href="mailto:info@all-about-artists.de" onClick={() => setOpen(false)} className="mono-label mt-3 inline-flex rounded-full bg-[var(--crtr-yellow)] px-5 py-2 text-xs text-black">
            LET’S TALK
          </a>
        </div>
      )}
    </header>
  );
}
